import { useQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  GetContractUpliftCaps,
  GetContractUpliftCapsVariables
} from '../upliftCaps.types';
// TODO: Replace with codegen import once available:
// import { GetContractUpliftCaps, GetContractUpliftCapsVariables }
//   from '@/graphql/contracts/_generated_/getContractUpliftCaps.query';
import GetContractUpliftCapsQuery from '@/graphql/contracts/getContractUpliftCaps.query.gql';
import { notificationService } from '@/services/notification/notification.client';

export default function useGetContractUpliftCaps(contractId: UUID) {
  const { data, error, loading, refetch } = useQuery<
  GetContractUpliftCaps,
  GetContractUpliftCapsVariables
  >(
    GetContractUpliftCapsQuery,
    {
      client: apolloClientContracts,
      fetchPolicy: 'cache-and-network',
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      variables: { contractId }
    }
  );

  return {
    upliftCaps: data?.contractUpliftCaps ?? null,
    isLoading: loading,
    error,
    refetch
  } as const;
}
